import {Fragment, useEffect, useRef} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowDown, faArrowUp} from "@fortawesome/free-solid-svg-icons";
import {ErrorMessage, Field} from "formik";
import SelectField from "../forms/select";
import {Collapse} from "bootstrap";

const EntriesMobileAccordion = ({athleteRowCount, substitutionsToggleMode, isEditable, values, errors, touched, setTouched, clubs, customFilter, checkClubValue, handleDateChange, validateField, handleDateBlur, setFieldValue, entry, event, toggleAthleteSubstitution, handleReorder, selectKey, setShowModal, saveAthleteSubstitution}) => {
	const entryAccordion = useRef(null);

	useEffect(() => {
		if (entryAccordion.current !== null) {
			const collapses = entryAccordion.current.querySelectorAll('.accordion-collapse');
			collapses.forEach(collapseElement => {
				new Collapse(collapseElement, {
					toggle: false
				});
			});
		}
	}, [entryAccordion]);

	return (
		<div className="entry-accordion form-group" id="accordionExample" ref={entryAccordion}>
			{Array.from({length: athleteRowCount}, (_, index) => {
					const isSubstituteEditable = values.athletes[index]?.substitute_status !== 'requested';
					const isAthleteEditable = isEditable || (values.athletes[index]?.replaced_crew_member_id && isSubstituteEditable && substitutionsToggleMode === 'editing');
					const hasSubstitute = values.athletes.find(a => a?.replaced_crew_member_id && a?.replaced_crew_member_id === values.athletes[index].crew_member_id) || false;
					const isSubstitute = values.athletes[index]?.replaced_crew_member_id;

					return (
						<Fragment key={index}>
							<div className={`entry-accordion-item ${isSubstitute ? 'substitute-row' : ''} ${hasSubstitute ? 'has-substitute-row' : ''}`.trim()}>
								{substitutionsToggleMode !== "hidden" && (
									<div data-title="Substitute" className="entry-accordion-field">
										{substitutionsToggleMode === "editing" && !isSubstitute && isSubstituteEditable ? (
											<input
												type="checkbox"
												className="form-check-input"
												checked={hasSubstitute}
												disabled={hasSubstitute && hasSubstitute?.substitute_status === 'requested'}
												onChange={() => toggleAthleteSubstitution(index, values, setFieldValue)}
											/>
										) : isSubstitute ? (
											<><p className="substitute-label">Substitute with</p></>
										) : null}
									</div>
								)}
								{!isSubstitute && (
									<>
										<div className="entry-accordion-header">
											<div data-title="Change position" className="entry-accordion-field position-controls">
												<button
													type="button"
													onClick={() => handleReorder(index, index - 1, values, setFieldValue)}
													disabled={index === 0 || !isAthleteEditable}
													className="btn btn-reorder btn-reorder--up"
												><FontAwesomeIcon icon={faArrowUp}/></button>
												<button
													type="button"
													onClick={() => handleReorder(index, index + 1, values, setFieldValue)}
													disabled={index === values.athletes.length - 1 || !isAthleteEditable}
													className="btn btn-reorder btn-reorder--down"
												>
													<FontAwesomeIcon icon={faArrowDown}/>
												</button>
												<button
													className={`btn btn-accordion-toggle ${index > 0 ? 'collapsed' : ''}`}
													type="button"
													data-bs-toggle="collapse"
													data-bs-target={`#collapse-${index}`}
													aria-expanded={index === 0}
													aria-controls={`collapse-${index}`}
												>
												</button>
											</div>
											<div data-title="Position" className="entry-accordion-field position">
												<Field type="text" className="form-control" name={`athletes[${index}].position`} disabled />
												<ErrorMessage name={`athletes[${index}].position`} component="div" className="field-error" />
											</div>
											{(event.event_types.steer === 1) && (
												<div data-title="Steer" className="entry-accordion-field steer">
													<Field type="radio" name="steer" value={index} checked={values.steer === index.toString()} disabled={!isAthleteEditable}
														// if this is an error field
														   className={(errors.steer && touched.steer) ? 'is-invalid' : ''}
													/>
													{(touched.steer && touched.steer !== true) && (
														<div className="field-error">{touched.steer}</div>
													)}
													{/* <ErrorMessage name="steer" component="div" className="field-error" /> */}
												</div>
											)}
										</div>
									</>
								)}
								<div id={`collapse-${index}`} className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`} data-bs-parent="#accordionExample">

								<div data-title="Club" className="entry-accordion-field">
									<Field
										showIndicators={false}
										placeholder="Start typing your Club name.."
										key={selectKey}
										isDisabled={(event.composite === 0 && index !== 0 || !isAthleteEditable) ? true:false}
										component={SelectField}
										name={`athletes[${index}].club`}
										className="form-control"
										options={clubs}
										filterOption={customFilter}
										onChange={(value) => checkClubValue(value, index, values, setFieldValue)}
										noOptionsMessage={({ inputValue }) => {
											if (inputValue) {
												return (
													<div
														style={{ cursor: "pointer" }}
														onClick={() => setShowModal(true)}
													>
														Create new club "{inputValue}"
													</div>
												);
											} else {
												return "No options";
											}
										}} />
									<ErrorMessage name={`athletes[${index}].club`} component="div" className="field-error" />
								</div>
								<div data-title="First Name" className="entry-accordion-field">
									<Field type="text" className="form-control" name={`athletes[${index}].first_name`}  disabled={!isAthleteEditable}/>
									<ErrorMessage name={`athletes[${index}].first_name`} component="div" className="field-error" />
								</div>
								<div data-title="Middle Initials (1 per field)" className="entry-accordion-field">
									<div className="d-flex ms-n1">
										<div className="px-1">
											<Field type="text" className="form-control" name={`athletes[${index}].initials[0]`}  disabled={!isAthleteEditable} />
											<ErrorMessage name={`athletes[${index}].initials[0]`} component="div" className="field-error" />
										</div>
										{(values.athletes?.[index].initials?.[0]?.length > 0) &&
											<div className="px-1">
												<Field type="text" className="form-control" name={`athletes[${index}].initials[1]`}  disabled={!isAthleteEditable} />
												<ErrorMessage name={`athletes[${index}].initials[1]`} component="div" className="field-error" />
											</div>
										}
										{(values.athletes?.[index]?.initials?.[1]?.length > 0) &&
											<div className="px-1">
												<Field type="text" className="form-control" name={`athletes[${index}].initials[2]`}  disabled={!isAthleteEditable} />
												<ErrorMessage name={`athletes[${index}].initials[2]`} component="div" className="field-error" />
											</div>
										}
									</div>
								</div>
								<div data-title="Last Name" className="entry-accordion-field">
									<Field type="text" className="form-control" name={`athletes[${index}].last_name`}  disabled={!isAthleteEditable}/>
									<ErrorMessage name={`athletes[${index}].last_name`} component="div" className="field-error" />
								</div>
									<div
										data-title="Date of Birth (dd/mm/yyyy)"
										className={`entry-accordion-field`}
									>
									<Field type="text" className="form-control datepicker-dob" name={`athletes[${index}].dob`}  disabled={!isAthleteEditable} onChange={input => handleDateChange(input, `athletes[${index}].dob`, setFieldValue)} onBlur={input => handleDateBlur(input, `athletes[${index}].dob`, setFieldValue)} />
									<ErrorMessage name={`athletes[${index}].dob`} component="div" className="field-error" />
								</div>
								<div data-title="Has this athlete competed at HRR before, excluding Qualifiers?" className="entry-accordion-field">
									<Field component={SelectField} name={`athletes[${index}].previously_rowed`} className="form-control" options={[{ value: 1, label: "Yes" }, { value: 0, label: "No"}]} isDisabled={!isAthleteEditable} />
									<ErrorMessage name={`athletes[${index}].previously_rowed`} component="div" className="field-error" />
								</div>
							</div>
							</div>

							{substitutionsToggleMode === 'editing' && isSubstitute && isSubstituteEditable && (
								<div>
									<div className="substitute-action-buttons">
										<button type="button"
												className="btn btn-outline-primary"
												onClick={() => toggleAthleteSubstitution(index - 1, values, setFieldValue)}>
											Cancel substitution
										</button>
										<button type="button" className="btn btn-primary" onClick={() => saveAthleteSubstitution(index - 1, values, setFieldValue, setTouched)}>
											Save substitution
										</button>
									</div>
								</div>
							)}
						</Fragment>
					)
				}
			)}
		</div>
	)
}
export default EntriesMobileAccordion;

